import ToolbarButton from "@cirrus/legacy/app-components/buttons/toolbar-button"
import React from "react"

import styles from "./index.less"

export const getButton = (props, handleShowMenu) => {
  let button = getDefaultButton(props, handleShowMenu)

  if (props.button) {
    button = getCustomButton(props, handleShowMenu)
  } else if (props.buttonIcon) {
    button = getIconButton(props, handleShowMenu)
  }

  return button
}

export const getCustomButton = (props, handleShowMenu) =>
  React.cloneElement(props.button, {
    onClick: () => !props.disabled && handleShowMenu(),
  })

export const getIconButton = (props, handleShowMenu) => (
  <ToolbarButton
    dataQa={props.iconDataQa}
    onClick={handleShowMenu}
    type={props.type}
    icon={props.buttonIcon}
    iconAfter="fa-chevron-down"
    iconAfterClassName={styles.chevron}
    disabled={props.disabled}
    tabIndex={-1}>
    <span className={styles.buttonTitle}>{props.buttonText}</span>
  </ToolbarButton>
)

export const getDefaultButton = (props, handleShowMenu) => (
  <ToolbarButton
    id={props.iconDataQa}
    onClick={handleShowMenu}
    className={styles.button}
    disabled={props.disabled}
    tabIndex={-1}>
    {props.buttonText && <span className={styles.buttonTitle}>{props.buttonText}</span>}
    <span className="caret" />
  </ToolbarButton>
)
